import Loader from '@bharatpe/bharat-ui/web/Loader';
import { makeStyles } from '@bharatpe/bharat-ui/web/Styles';
import React, { useEffect, useState } from 'react';
import { triggerJuspayPaymentModesApi, JuspayPaymentModesSlice, useJuspayPaymentModes } from 'Slices';
import { useDispatch } from 'react-redux';
import Toasty from 'components/atoms/Toasty';
import Box from '@bharatpe/bharat-ui/web/Box';
import Icon from '@bharatpe/bharat-ui/web/Icon';
import { ArrowBackOutlined } from '@bharatpe/bharat-ui/web/Icons';
import { getURLParameter } from 'utils/nativeSupport';
import { registerSlice } from 'store';
import { useHistory, useParams } from 'react-router-dom';
import HeaderPostPe from 'components/atoms/HeaderPostPe';
import Radio from '@bharatpe/bharat-ui/web/Radio';
import { NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import Icon1 from 'assets/images/Icons.svg';
import bharatPeIcon from 'assets/images/bharatpe-icon.png';
import { formatCurrency } from 'utils/formatCurrency';
import { globalId } from 'index';
import NotFound from 'components/atoms/NotFound';
import postPeFailed from 'assets/images/failed.svg';
import { CancelPaymentApi, PostJuspayFpAndOtherModes, UpdateCheckoutType } from 'Services';
import { saveState } from 'utils/LocalStorage';

registerSlice(JuspayPaymentModesSlice);

const useStyle = makeStyles(() => ({
	mainContainer: {
		background: '#ffffff',
		height: '100vh',
	},
	marginCont: {
		margin: '0 1rem',
	},
	unityPaymentAmountCard: {
		borderRadius: '10px',
		backgroundColor: '#FFFFFF',
		overflow: 'hidden',
		boxShadow: '0px 2px 25px rgba(0, 0, 0, 0.15)',
		marginTop: '0.75rem',
	},
	amountPayStyle: {
		fontFamily: 'PoppinsLight',
		fontSize: '13px',
		lineHeight: '19px',
		color: '#4F4F4F',
	},
	amountPayValue: {
		fontFamily: 'PoppinsHeavy',
		fontSize: '18px',
		lineHeight: '30px',
		color: '#1F1F1F',
	},
	paymentModesTitle: {
		fontFamily: 'PoppinsHeavy',
		fontSize: '13px',
		lineHeight: '19px',
		color: '#1F1F1F',
	},
	paymentModesSubTitle: {
		fontFamily: 'PoppinsLight',
		fontSize: '11px',
		lineHeight: '16px',
		color: '#4F4F4F',
	},
	rupeeSymbolUnity: {
		fontSize: '18px',
		lineHeight: '30px',
		color: '#1F1F1F',
	},
	bharatpeIcon: {
		width: '18px',
	},
	footerNewContainer: {
		bottom: '0',
		left: '0',
		zIndex: 9,
		background: '#ffffff',
	},
	postpeButton: {
		border: '1px solid #009CDE',
		borderRadius: '10px',
		textAlign: 'center',
		display: 'inline-block',
		width: '90%',
		background: '#2B80FF',
		color: '#FFFFFF',
		fontSize: '1rem',
		fontFamily: 'PoppinsHeavy',
		padding: '12px 18px',
		textTransform: 'capitalize',
		outline: 'none',
	},
	paymentHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
	paymentSubHeader: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		paddingTop: '8px',
		color: '#FFFFFF',
	},
	paddingZero: {
		padding: '0 !important',
	},
	divider1: {
		height: '1px',
		background: 'lightgrey',
	},
	opacityCard: {
		opacity: '0.5',
	},
	capsuleCard: {
		borderRadius: '9px',
		padding: '4px 8px',
	},
	recommendedCard: {
		background: '#F1F9F3',
		color: '#34A853',
		fontFamily: 'Poppins',
		fontSize: '10px',
		lineHeight: '15px',
	},
	comingSoonCard: {
		background: '#FFFCF2',
		color: '#FBBC05',
		fontFamily: 'Poppins',
		fontSize: '10px',
		lineHeight: '15px',
	},
	headerBottom: {
		boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
	},
	errorColor: {
		color: '#E20613',
	},
}));

const JuspayLandingPage: React.FC = () => {
	const classes = useStyle();
	const dispatch = useDispatch();
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [errorState, setErrorState] = useState(false);
	const [isBpAccountSelected, setIsBpAccountSelected] = useState(false);
	const [isBpAccountDisabled, setIsBpAccountDisabled] = useState(true);
	const [isOtherModesDisabled, setIsOtherModesDisabled] = useState(false);
	const [isFpModeTriggered, setIsFpModeTriggered] = useState(false);
	const [fpPaymentModeData, setFpPaymentModeData] = useState<any>({});
	const [isUPIModeSelected, setIsUPIModeSelected] = useState(false);

	const juspayPaymentModesData = useJuspayPaymentModes();
	const checkout = getURLParameter(window.location.href, 'checkout') || '';

	const params: any = useParams();

	useEffect(() => {
		dispatch(triggerJuspayPaymentModesApi({ checkout }));
	}, []);

	useEffect(() => {
		if (juspayPaymentModesData?.data?.transaction) {
			const { paymentMethods, transaction } = juspayPaymentModesData?.data;
			saveState('backUriDeeplink', transaction?.redirectURIDeeplink || '', true);
			if (paymentMethods && paymentMethods.length > 0) {
				paymentMethods.map((item: any) => {
					if (item?.code === 'FP') {
						if (transaction?.orderAmount > item?.amount) {
							if (params?.checkout === 'juspay') {
								if (juspayPaymentModesData?.data?.payloads?.bpx) {
									setIsUPIModeSelected(true);
								} else {
									history.push('/juspay-landing/bharatpe');
								}
								return;
							}
						}
						setIsBpAccountSelected(item?.enabled);
						setIsBpAccountDisabled(!item?.enabled);
						setFpPaymentModeData(item);
						setLoading(false);
						return;
					}
				});
			} else {
				if (juspayPaymentModesData?.data?.payloads?.bpx) {
					setIsUPIModeSelected(true);
					setLoading(false);
				} else {
					if (params?.checkout === 'juspay') {
						history.push('/juspay-landing/bharatpe');
						return;
					}
				}
				return;
			}
		}
		setLoading(false);
	}, [juspayPaymentModesData?.data?.transaction, dispatch]);

	useEffect(() => {
		if (juspayPaymentModesData.error.length > 1) {
			setErrorState(true);
			setLoading(false);
		}
	}, [juspayPaymentModesData.error.length > 1 && !juspayPaymentModesData.loading]);

	const redirectToSource = () => {
		NativeSupportHandlerV2.openDeeplink(juspayPaymentModesData?.data?.transaction?.redirectURIDeeplink);
	};

	const TriggerCancelPaymentApi = () => {
		setLoading(true);
		CancelPaymentApi({ txnId: globalId })
			.then((resp: any) => {
				redirectToSource();
			})
			.catch((err) => {
				redirectToSource();
				Toasty.error('Something went wrong');
			});
	};

	const TriggerPostJuspayFpMode = () => {
		setIsFpModeTriggered(true);
		setLoading(true);
		PostJuspayFpAndOtherModes({
			checkout,
			request: {
				paymentMode: 'FP',
			},
		})
			.then((resp: any) => {
				if (resp.status_code !== '200') {
					setLoading(false);
					Toasty.error(resp.api_msg);
					return;
				}
				redirectToSource();
			})
			.catch((err) => {
				setLoading(false);
				Toasty.error(err.message);
			});
	};

	const TriggerPostJuspayOtherMode = () => {
		setLoading(true);
		PostJuspayFpAndOtherModes({
			checkout,
			request: {
				paymentMode: 'JUSPAY',
				payload: juspayPaymentModesData?.data?.payloads?.process,
			},
		})
			.then((resp: any) => {
				if (resp.status_code !== '200') {
					redirectToSource();
					return;
				}
				history.push('/juspay-landing/bharatpe');
			})
			.catch((err) => {
				Toasty.error(err.message);
				redirectToSource();
			});
	};

	const handleBack = () => {
		if (juspayPaymentModesData?.data?.transaction?.paymentStatus === 'INIT') {
			TriggerCancelPaymentApi();
			return;
		}
		redirectToSource();
	};

	const getRecommendedCapsule = (type = 'recommended') => {
		return (
			<div
				className={`${classes.capsuleCard} ${
					type === 'recommended' ? classes.recommendedCard : classes.comingSoonCard
				} flex flex-center flex-justify`}>
				<span>{type === 'recommended' ? 'Recommended' : 'Coming Soon'}</span>
			</div>
		);
	};

	const TriggerUpdateCheckoutApi = async (payload: any) => {
		const response = await UpdateCheckoutType(payload);
		console.log(response);
	};

	const handleRetry = () => {
		dispatch(triggerJuspayPaymentModesApi({ checkout }));
	};

	return (
		<div className={classes.mainContainer}>
			<Loader loading={loading || juspayPaymentModesData.loading} />
			<HeaderPostPe
				leftIconAction={handleBack}
				title={juspayPaymentModesData?.data?.headerText || 'Payment'}
				leftIcon={<Icon icon={ArrowBackOutlined} color="dark" />}
				className={classes.headerBottom}
			/>

			{errorState ? (
				<div>
					{(errorState ||
						(juspayPaymentModesData && juspayPaymentModesData?.data?.paymentMethods?.length === 0) ||
						juspayPaymentModesData?.data == undefined ||
						null) && <NotFound onRetry={() => handleRetry()} />}
				</div>
			) : (
				<>
					<Box className={`${classes.unityPaymentAmountCard} p4 mb6 mt6 mx4`}>
						<Box display="flex" flexDirection="column">
							<Box className={classes.paymentHeader}>
								<span className={classes.amountPayStyle}>Paying to:</span>
								<span className={classes.amountPayStyle}>Amount</span>
							</Box>
							<Box className={classes.paymentSubHeader}>
								<span className={classes.amountPayValue}>BharatPe</span>
								<div className="">
									<span className={classes.rupeeSymbolUnity}>₹&nbsp;</span>
									<span className={classes.amountPayValue}>{`${formatCurrency(
										juspayPaymentModesData?.data?.transaction?.orderAmount,
									)}`}</span>
								</div>
							</Box>
						</Box>
					</Box>

					<Box className={`${classes.unityPaymentAmountCard} p4 mb6 mx4`}>
						<div className={`flex flex-column width-100`}>
							<>
								<div
									className={`flex flex-start pb4`}
									onClick={() => {
										if (isBpAccountDisabled) return;
										setIsBpAccountSelected(true);
									}}>
									<Radio
										checked={isBpAccountSelected}
										className={`mr2 ${classes.paddingZero} ${isBpAccountDisabled ? classes.opacityCard : ''}`}
									/>
									<div className="flex flex-column width-100">
										<Box className={`${classes.paymentHeader} ${isBpAccountDisabled ? classes.opacityCard : ''}`}>
											<span className={classes.paymentModesTitle}>BharatPe Account</span>
											{!isBpAccountDisabled && getRecommendedCapsule()}
											{/* {isBpAccountDisabled && !fpPaymentModeData?.code && getRecommendedCapsule('soon')} */}
										</Box>
										{fpPaymentModeData?.code && (
											<Box className={`${classes.paymentSubHeader} ${isBpAccountDisabled ? classes.opacityCard : ''}`}>
												<span className={`${classes.paymentModesSubTitle}`}>Available Balance</span>
												<span className={` ${classes.paymentModesSubTitle}`}>{`₹${formatCurrency(
													fpPaymentModeData?.amount || 0,
												)}`}</span>
											</Box>
										)}
										{isBpAccountDisabled &&
											fpPaymentModeData?.code &&
											fpPaymentModeData?.amount < juspayPaymentModesData?.data?.transaction?.orderAmount && (
												<Box display="flex" alignItems="center" className={`mt3`}>
													<img src={postPeFailed} style={{ width: '14px' }} className="mr1" />
													<p className={`${classes.paymentModesSubTitle} ${classes.errorColor}`}>
														Insufficient Balance
													</p>
												</Box>
											)}
									</div>
								</div>
								<div className={classes.divider1}></div>
							</>
							{(checkout === 'BPX' || juspayPaymentModesData?.data?.payloads?.bpx) && (
								<>
									<div
										className={`flex flex-start pt4 pb4 ${isOtherModesDisabled ? classes.opacityCard : ''}`}
										onClick={() => {
											if (isOtherModesDisabled) return;
											setIsBpAccountSelected(false);
											setIsUPIModeSelected(true);
										}}>
										<Radio
											checked={!isBpAccountSelected && isUPIModeSelected}
											className={`mr2 ${classes.paddingZero}`}
										/>
										<div className="flex flex-column width-100">
											<Box className={classes.paymentHeader}>
												<span className={classes.paymentModesTitle}>UPI</span>
											</Box>
										</div>
									</div>
									<div className={classes.divider1}></div>
								</>
							)}

							<div
								className={`flex flex-start pt4 ${isOtherModesDisabled ? classes.opacityCard : ''}`}
								onClick={() => {
									if (isOtherModesDisabled) return;
									setIsUPIModeSelected(false);
									setIsBpAccountSelected(false);
								}}>
								<Radio checked={!isBpAccountSelected && !isUPIModeSelected} className={`mr2 ${classes.paddingZero}`} />
								<div className="flex flex-column width-100">
									<Box className={classes.paymentHeader}>
										<span className={classes.paymentModesTitle}>Other Modes</span>
										<span className={classes.paymentModesSubTitle}></span>
									</Box>
									{checkout === 'BPX' || juspayPaymentModesData?.data?.payloads?.bpx ? (
										<Box className={classes.paymentSubHeader}>
											<span className={`grey ${classes.paymentModesSubTitle}`}>Net Banking and Cards</span>
											<span className={`grey ${classes.paymentModesSubTitle}`}></span>
										</Box>
									) : (
										<Box className={classes.paymentSubHeader}>
											<span className={`grey ${classes.paymentModesSubTitle}`}>UPI, Net Banking and Cards</span>
											<span className={`grey ${classes.paymentModesSubTitle}`}></span>
										</Box>
									)}
								</div>
							</div>
						</div>
					</Box>

					<Box display="flex" flexDirection="row" justifyContent="center">
						<img src={Icon1} className="mr2" />
						<span className={classes.amountPayStyle}>100% SAFE & SECURE</span>
					</Box>

					<Box display="flex" alignItems="center" justifyContent="center" className="mt6">
						<span className={`mr1 grey ${classes.amountPayStyle}`}>Powered By BharatPe</span>
						<img src={bharatPeIcon} className={classes.bharatpeIcon} />
					</Box>

					<div className={`${classes.footerNewContainer} pb2 px1 flex flex-center flex-justify-center width-100 fixed`}>
						<button
							className={`${classes.postpeButton}`}
							onClick={() => {
								if (isBpAccountSelected) {
									TriggerPostJuspayFpMode();
									return;
								}
								if (isUPIModeSelected && (checkout === 'BPX' || juspayPaymentModesData?.data?.payloads?.bpx)) {
									if (juspayPaymentModesData?.data?.payloads?.bpx) {
										TriggerUpdateCheckoutApi({ checkout: 'BPX' });
									}
									history.push('/bpx-landing/bharatpe');
									return;
								}
								if (isFpModeTriggered) {
									TriggerPostJuspayOtherMode();
									return;
								}
								if (checkout === 'BPX') {
									TriggerUpdateCheckoutApi({ checkout: 'JUSPAY' });
								}
								history.push('/juspay-landing/bharatpe');
							}}
							disabled={false}>
							{`PAY ₹${formatCurrency(juspayPaymentModesData?.data?.transaction?.orderAmount)} NOW`}
						</button>
					</div>
				</>
			)}
		</div>
	);
};

export default JuspayLandingPage;
